import { render, staticRenderFns } from "./AddOrganizationComponent.vue?vue&type=template&id=20db30aa&"
import script from "./AddOrganizationComponent.vue?vue&type=script&lang=js&"
export * from "./AddOrganizationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports